export default "__VITE_ASSET__CH0vcd3T__"